import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type AddressRequest = {
  clientId?: string | null;
  type?: string | null;
  propertyNumber?: string | null;
  buildingName?: string | null;
  line?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  lastActionBy?: string | null;
};

export type Address = {
  id: string;
  clientId: string;
  type: string;
  propertyNumber?: string | null;
  buildingName?: string | null;
  line: string;
  city: string;
  state?: string | null;
  postalCode?: string | null;
  country: string;
  fromDate?: string | null;
  toDate?: string | null;
  lastActionBy?: string | null;
  createdAt: string;
  updatedAt: string;
};

export class Addresses extends Resource<AddressRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("addresses", axiosInstance);
  }

  public async create(
    clientId: string,
    addressRequest: AddressRequest
  ): Promise<Address> {
    return this.request({
      method: Method.POST,
      body: { clientId, ...addressRequest }
    });
  }

  public async get(id: string): Promise<Address> {
    return this.request({ method: Method.GET, path: id });
  }

  public async update(
    id: string,
    addressRequest: AddressRequest
  ): Promise<Address> {
    return this.request({
      method: Method.POST,
      path: id,
      body: addressRequest
    });
  }

  public async delete(id: string): Promise<void> {
    await this.request({ method: Method.DELETE, path: id });
  }

  public async list(
    clientId: string,
    {
      page,
      pageSize
    }: {
      page?: number;
      pageSize?: number;
    } = {}
  ): Promise<Address[]> {
    const { items: addresses } = await this.request({
      method: Method.GET,
      query: { clientId, page, pageSize }
    });

    return addresses;
  }
}
